import { RowClickedEvent } from "@ag-grid-community/core";
import { PointerEvent, useCallback } from "react";
import { useClickableElementOnClickHandler } from "shared/components/clickable/ClickableElementOnClickHandler";
import { DataTableContext } from "shared/components/table/data/DataTableContext";

export const useDataTableRowClickAgProps = ({
  getLinkInfoForRow,
}: DataTableContext) => {
  const onClickLink = useClickableElementOnClickHandler();
  const onRowClicked = useCallback(
    (event: RowClickedEvent) => {
      const pointerEvent = event.event as PointerEvent | undefined;
      if (!pointerEvent || !event.data || event.node.isRowPinned()) {
        return;
      }
      const linkInfo = getLinkInfoForRow?.({
        row: event.node,
      });
      if (linkInfo) {
        onClickLink(linkInfo, pointerEvent);
      }
    },
    [getLinkInfoForRow, onClickLink],
  );
  return {
    onRowClicked,
  };
};
